import * as React from 'react';

export interface Props {
    onChange: (value: string, field: string) => void;
    id: string;
    field: string;
    value: string | number;
    label: string;
    checked: boolean;
    isCheckbox: boolean; // checkbox or radio box
    extendClass?: string;
    extendLableClass?: string;
    disabled?: boolean;
}

export interface State {
}

class CheckBox extends React.Component<Props, State> {
    maskString: string;
    constructor(props: Props) {
        super(props);
    }

    componentDidMount() {
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        let value = e.target.value;
        if (e.target.value === this.maskString) {
            value = '';
        }
        this.props.onChange(value, this.props.field);
    }

    render(): JSX.Element {
        const { id, extendClass, extendLableClass, checked, disabled, isCheckbox, label, value } = this.props;

        return (
            <div className={'custom-control ' + (isCheckbox ? 'custom-checkbox ' : 'custom-radio ') + (extendClass || '')}>
                <input
                    id={id}
                    type={isCheckbox ? 'checkbox' : 'radio'}
                    className="custom-control-input"
                    checked={checked}
                    value={value ? value : ''}
                    onChange={this.handleChange}
                    disabled={disabled}
                />
                <label className={'custom-control-label ' + (extendLableClass || '')} style={{}} htmlFor={id}>{label}</label>
            </div>
        );
    }
}

export default CheckBox;


// WEBPACK FOOTER //
// ./src/components/shared/CheckBox/CheckBox.tsx